// Parse and validate a report object (from sample-report.js or parsed YAML in step 5).

const PAUSE_DEFAULTS = { text: 10, media: 20, question: 15 }

export function parseReport(data) {
  if (!data || data.type !== 'correspond-report') {
    return { report: null, error: 'Not a correspond-report' }
  }
  if (!Array.isArray(data.sections)) {
    return { report: null, error: 'Missing sections array' }
  }

  const sections = []
  for (const s of data.sections) {
    if (!s.type || !s.id) continue
    const pause = s.pause ?? PAUSE_DEFAULTS[s.type] ?? 10
    switch (s.type) {
      case 'text':
        sections.push({ ...s, title: s.title ?? '', content: s.content ?? '', pause })
        break
      case 'media':
        sections.push({ ...s, title: s.title ?? '', file: s.file ?? '', caption: s.caption ?? '', pause })
        break
      case 'question':
        sections.push({
          ...s,
          options: s.options ?? [],
          required: s.required !== false, // default true
          pause,
        })
        break
      // unknown types silently skipped — forward compatible
    }
  }

  return { report: { ...data, sections }, error: null }
}

// How many questions appear up to and including index (1-based for TTS reading).
export function questionNumber(sections, index) {
  return sections.slice(0, index + 1).filter(s => s.type === 'question').length
}
